export const MAINNET_JOY_ID_APP_URL = 'https://app.joy.id'
export const TESTNNET_JOY_ID_APP_URL = 'https://app.joyid.dev'
export const MAINNET_JOYID_SERVER_URL = 'https://api.joy.id/api/v1'
export const TESTNET_JOYID_SERVER_URL = 'https://api.joyid.dev/api/v1'

class Config {
  appURL: string = TESTNNET_JOY_ID_APP_URL

  serverURL: string = TESTNET_JOYID_SERVER_URL

  network: string = 'testnet'

  getJoyIDAppURL(): string {
    return this.appURL
  }

  setJoyIDAppURL(url: string): void {
    this.appURL = url
  }

  getJoyIDServerURL(): string {
    return this.serverURL
  }

  setJoyIDServerURL(url: string): void {
    this.serverURL = url
  }

  setNetWork(network: 'mainnet' | 'testnet'): void {
    this.network = network
  }
}

export const config = new Config()
